/**
 * 心成品牌標記（文字＋無限符號）。
 *
 * 舊站 header 用的是點陣圖 logo-sm.webp（frontend/views/layouts/partial 之
 * navbar-brand，見 legacy header.html：<img src=".../logo-sm.webp" alt="心成教育">）。
 * 本骨架尚未取得該圖檔資產，先以同語意的行內 SVG 字標佔位，
 * alt/可讀文字沿用舊站 alt="心成教育"；正式圖檔到位後直接替換本元件內容即可，
 * 呼叫端（Header）介面不受影響。
 */
export function Logo({ className }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center gap-2 text-lg font-semibold tracking-wide text-stone-800 ${className ?? ""}`}
      role="img"
      aria-label="心成教育"
    >
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        aria-hidden="true"
        className="shrink-0"
      >
        <path
          d="M7 14c0-2.2 1.8-4 4-4 2.4 0 3.6 2 4 4 0.4 2 1.6 4 4 4 2.2 0 4-1.8 4-4s-1.8-4-4-4c-2.4 0-3.6 2-4 4-0.4 2-1.6 4-4 4-2.2 0-4-1.8-4-4z"
          stroke="currentColor"
          strokeWidth="1.6"
          className="text-amber-700"
        />
      </svg>
      <span>心成</span>
    </span>
  );
}
